import axios from "axios";
import AxiosInterceptors from "../api/AxiosInterceptors";

const URL = window.location.origin;
const ROOT_URL = `https://onboardingapi.financialdataexchange.org/onboardingapi`;
const CLIENT_ID = `fb838b98-fde9-4ebc-867d-ef24afcf10e8`;
const DOCUSIGN_ROOT_URL = `https://account.docusign.com`;
const SSO_ROOT = `https://sso.financialdataexchange.org/`
const SSO_SIGNOUT_URL = `${SSO_ROOT}openid/signout?id_token_hint=id_token_value&post_logout_redirect_uri=`;

export default {
  checkEmailVal: function (request) {
    return axios.get(`${ROOT_URL}/user/email/validate/` + request);
  },
  sendVerifyEmail: function (request) {
    return axios.post(`${ROOT_URL}/user/email/initiateVerifyEmail`, request);
  },
  verifyEmail: function (request) {
    return axios.get(
      `${ROOT_URL}/user/email/verify?reqid=` +
      request.reqid +
      `&otp=` +
      request.otp
    );
  },
  getUserRequest: function (request) {
    return axios.get(`${ROOT_URL}/user/request/` + request);
  },
  accountRegistrationAbandonment: function (request) {
    return axios.get(`${ROOT_URL}/user/request/abandon/` + request);
  },
  createUserAndOrganization: function (request) {
    return axios.post(`${ROOT_URL}/user/request/create`, request);
  },
  getEnumTypes: function () {
    return axios.get(`${ROOT_URL}/util/enumtypes`);
  },
  getCountries: function () {
    return axios.get(`${ROOT_URL}/util/countries`);
  },
  checkOfacVal: function (request) {
    return axios.get(`${ROOT_URL}/org/ofac/screening/` + encodeURIComponent(request));
  },
  getOrganizationList: function (request) {
    return axios.get(`${ROOT_URL}/org/getlist/` + request);
  },
  getDomainsByOrganization: function (request) {
    return axios.get(`${ROOT_URL}/org/getdomainlist/` + request);
  },
  initiateDocusign: function (type) {
    let redirect_uri = window.location.origin + "/authDocusign";
    let url =
      DOCUSIGN_ROOT_URL +
      "/oauth/auth?response_type=code&scope=signature impersonation&client_id=" +
      CLIENT_ID +
      "&state=" +
      type +
      "&redirect_uri=" +
      redirect_uri;
    window.location.replace(url);
  },
  getDocuSignAccessToken: function (request) {
    return axios.get(
      `${ROOT_URL}/user/docusign/accesstoken/` + request.code
    );
  },
  getDocuSignUserInfo: function (request) {
    return axios.get(
      `${ROOT_URL}/user/docusign/userinfo/` + request.token
    );
  },
  initiateSigning: function (request) {
    return axios.get(
      `${ROOT_URL}/user/docusign/signing?email=${request.email}&type=${request.type}`
    );
  },

  updateDocusignProgress: function (request) {
    return axios.get(
      `${ROOT_URL}/org/docusign/update/${request.envelopeid}/${request.email}`
    );
  },

  ssoAuthentication: function () {
    window.location.href = ROOT_URL + '/oauth2/authorization/fdx-openId';
  },
  ssoSignout: function (token) {
    let signoutUrl;
    if (token) {
      let jwt = JSON.parse(token).idToken;
      signoutUrl = SSO_SIGNOUT_URL.replace("id_token_value", jwt);
      signoutUrl = signoutUrl + URL;
    } else {
      signoutUrl = URL;
    }
    window.location.href = signoutUrl;
  },
  getAccessToken: function (authCode) {
    return axios.get(`${ROOT_URL}/auth/token/${authCode}`);
  },
  refreshToken: function () {
    return axios.get(`${ROOT_URL}/auth/refreshtoken`);
  },
  getUserInfo: function () {
    return AxiosInterceptors.get(`${ROOT_URL}/auth/userinfo`);
  },
  getUserRegistrations: function (request) {
    return axios.post(
      `${ROOT_URL}/org/getuserregistrations`,
      {
        "page": request?.page ? (request?.page - 1) : 0,
        "size": request?.size ? request?.size : 10,
        "sortByField":request?.sortByField,
        "orderType":request.orderType,
        "organizationFilter": request?.filters ? request?.filters : []
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${request?.token}`
        }
      }
    );
  },
  downloadSignedAgreement: function (request) {
    return axios.get(
      `${ROOT_URL}/org/docusign/download/${request?.id}`,
      {
        headers: {
          'Authorization': `Bearer ${request?.token}`,
          'Content-Type': 'application/x-www-form-urlencoded',
        }, 'responseType': 'blob',
      }
    );
  },
  saveChecklist: function (request) {
    return axios.post(
      `${ROOT_URL}/org/onboardingchecklist`,
      request[0],
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${request[1]}`
        }
      }
    );
  },
};